import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
export function Content() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Dialog.Title className={css({
        textStyle: {
          base: "headline",
          lg: "headline.large"
        },
        fontFamily: "chronicleDisplay",
        mt: "2",
        m: "[0]"
      })}>Keep going - it's worth it!</Dialog.Title><div><p className={css({
          textStyle: {
            base: "body",
            lg: "body.large"
          },
          m: "[0]",
          mb: "3"
        })}>Stick around for a few more steps to:</p><ul className={css({
          pl: "[20px]",
          m: "[0]",
          display: "flex",
          flexDirection: "column",
          gap: "1"
        })}><li className={css({
            textStyle: {
              base: "body",
              lg: "body.large"
            }
          })}>Get personalized recommendations with no impact to your credit</li><li className={css({
            textStyle: {
              base: "body",
              lg: "body.large"
            }
          })}>Narrow in on the best credit cards from our partners based on your preferences</li><li className={css({
            textStyle: {
              base: "body",
              lg: "body.large"
            }
          })}>Save time with our proprietary recommendation system</li></ul></div></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}